import { useMemo } from 'react'
import { LabFeatureFlags } from 'constants/lab'
import { useLabFeatureFlag } from 'hooks/FeatureFlag/useLabFeatureFlag'
import { useAppSelector } from 'hooks/reduxHooks'
import { isStatusMatchLabPayload } from 'loyalty/statusMatch/statusMatchTypes'
import type { StatusMatchCampaignConfig } from 'loyalty/statusMatch/statusMatchTypes'

function useStatusMatchCampaign(slug: string): StatusMatchCampaignConfig | undefined {
  const flag = useLabFeatureFlag(LabFeatureFlags.enableStatusMatch)
  const regionCode = useAppSelector(state => state.geo.currentRegionCode)

  return useMemo(() => {
    if (!flag?.enabled) return undefined

    const payload = flag.value
    if (!isStatusMatchLabPayload(payload)) return undefined
    if (payload.slug !== slug) return undefined
    if (!payload.allowedRegions.includes(regionCode)) return undefined

    return { config: payload }
  }, [flag, slug, regionCode])
}

export default useStatusMatchCampaign
